import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  PLATFORM_ID,
  SimpleChanges,
  inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BrandButtonComponent } from '../../brand-button/brand-button.component';

/**
 * Tenant-themed modal dialog (replaces PrimeNG p-dialog). Content goes in the
 * default slot, an optional action row in `[modal-footer]`. The parent owns the
 * `open` flag and sets it to false on `(closed)`.
 */
@Component({
  selector: 'app-modal',
  imports: [BrandButtonComponent],
  templateUrl: './modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ModalComponent implements OnChanges, OnDestroy {
  @Input()
  open = false;

  @Input()
  title = '';

  @Input()
  closable = true;

  /** Set false when the projected content brings its own padding. */
  @Input()
  padded = true;

  /** Tailwind max-width utility for the panel. */
  @Input()
  widthClass = 'max-w-xl';

  @Output()
  closed: EventEmitter<void> = new EventEmitter<void>();

  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open']) {
      this.lockScroll(this.open);
    }
  }

  ngOnDestroy(): void {
    this.lockScroll(false);
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    if (this.open && this.closable) {
      this.close();
    }
  }

  close() {
    this.closed.emit();
  }

  private lockScroll(lock: boolean) {
    if (this.isBrowser) {
      document.body.style.overflow = lock ? 'hidden' : '';
    }
  }
}
